import {
  ACTIVIDADES_ENDPOINT,
  ARCHIVOS_ENDPOINT,
  CATEOGRIAS_AMBIENTALES_ENDPOINT,
  CERCOS_PERIMETRALES_ENDPOINT,
  CLASES_TANQUE_ENDPOINT,
  CONTAMINANTES_ENDPOINT,
  CORRIENTES_RESIDUALES_ENDPOINT,
  DEPARTAMENTOS_ENDPOINT,
  DESTINOS_RESIDUOS_SOLIDOS_URBANOS_ENDPOINT,
  DESTINOS_RESIDUOS_TRATAMIENTOS_ENDPOINT,
  DESTINOS_VERTIDO_ENDPOINT,
  FRECUENCIAS_MONITOREO_ENDPOINT,
  FRECUENCIAS_RETIRO_ENDPOINT,
  LOCALIDADES_ENDPOINT,
  MATERIALES_ENDPOINT,
  PELIGROSIDADES_ENDPOINT,
  PERIODICIDADES_VUELCO_ENDPOINT,
  PROVEEDORES_ENDPOINT,
  PROVINCIAS_ENDPOINT,
  SUBCUENCAS_ENDPOINT,
  TECNOLOGIAS_TRATAMIENTO_ENDPOINT,
  TIPOS_MUESTREO_ENDPOINT,
  UNIDADES_ENDPOINT,
  ZONIFICACIONES_ENDPOINT,
  doDelete,
  doGet,
  doPut,
} from "../utils/api";

export async function listarProvincias(consulta, token) {
  return await doGet(PROVINCIAS_ENDPOINT, consulta, null, token);
}

export async function listarDepartamentos(consulta, token) {
  return await doGet(DEPARTAMENTOS_ENDPOINT, consulta, null, token);
}

export async function listarLocalidades(consulta, token) {
  return await doGet(LOCALIDADES_ENDPOINT, consulta, null, token);
}

export async function listarZonificaciones(consulta, token) {
  return await doGet(ZONIFICACIONES_ENDPOINT, consulta, null, token);
}

export async function listarTecnologiasTratamiento(consulta, token) {
  return await doGet(TECNOLOGIAS_TRATAMIENTO_ENDPOINT, consulta, null, token);
}

export async function listarFrecuenciasMonitoreo(consulta, token) {
  return await doGet(FRECUENCIAS_MONITOREO_ENDPOINT, consulta, null, token);
}

export async function listarFrecuenciasRetiros(consulta, token) {
  return await doGet(FRECUENCIAS_RETIRO_ENDPOINT, consulta, null, token);
}

export async function listarActividades(consulta, token) {
  return await doGet(ACTIVIDADES_ENDPOINT, consulta, null, token);
}

export async function listarCategoriasAmbientales(consulta, token) {
  return await doGet(CATEOGRIAS_AMBIENTALES_ENDPOINT, consulta, null, token);
}

export async function listarUnidades(consulta, token) {
  return await doGet(UNIDADES_ENDPOINT, consulta, null, token);
}

export async function buscarUnidad(codigo, token) {
  return await doGet(UNIDADES_ENDPOINT + `/${codigo}`, null, null, token);
}

export async function listarProveedores(consulta, token) {
  return await doGet(PROVEEDORES_ENDPOINT, consulta, null, token);
}

export async function listarSubcuencas(consulta, token) {
  return await doGet(SUBCUENCAS_ENDPOINT, consulta, null, token);
}

export async function listarDestinosResiduosTratamiento(consulta, token) {
  return await doGet(
    DESTINOS_RESIDUOS_TRATAMIENTOS_ENDPOINT,
    consulta,
    null,
    token,
  );
}

export async function listarDestinosVertido(consulta, token) {
  return await doGet(DESTINOS_VERTIDO_ENDPOINT, consulta, null, token);
}

export async function listarPeriodicidadesVuelco(consulta, token) {
  return await doGet(PERIODICIDADES_VUELCO_ENDPOINT, consulta, null, token);
}

export async function listarDestinosResiduosSolidosUrbanos(consulta, token) {
  return await doGet(
    DESTINOS_RESIDUOS_SOLIDOS_URBANOS_ENDPOINT,
    consulta,
    null,
    token,
  );
}

export async function listarMateriales(consulta, token) {
  return await doGet(MATERIALES_ENDPOINT, consulta, null, token);
}

export async function listarCorrientesResiduales(consulta, token) {
  return await doGet(CORRIENTES_RESIDUALES_ENDPOINT, consulta, null, token);
}

export async function listarPeligrosidades(consulta, token) {
  return await doGet(PELIGROSIDADES_ENDPOINT, consulta, null, token);
}

export async function listarTiposTanque(consulta, token) {
  return await doGet(CLASES_TANQUE_ENDPOINT, consulta, null, token);
}

export async function listarCercosPerimetrales(consulta, token) {
  return await doGet(CERCOS_PERIMETRALES_ENDPOINT, consulta, null, token);
}

export async function listarContaminantes(consulta, token) {
  return await doGet(CONTAMINANTES_ENDPOINT, consulta, null, token);
}

export async function listarTiposMuestreo(consulta, token) {
  return await doGet(TIPOS_MUESTREO_ENDPOINT, consulta, null, token);
}

export async function subirArchivo(nombre, tipoMIME, archivo, token) {
  const message = {
    nombre,
    tipoMIME,
    archivo,
  };
  return await doPut(ARCHIVOS_ENDPOINT, message, null, null, token);
}

export async function borrarArchivo(archivo, token) {
  return await doDelete(
    `${ARCHIVOS_ENDPOINT}/${archivo.id}`,
    null,
    null,
    token,
  );
}
